import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .illustration {
    height: 60vh;
    object-fit: contain;
  }
  .searchLink {
    text-align : center;
    border-radius: 0.75rem;
    border: none;
    background: hsl(0, 79%, 72%);
    color: white;
    padding: 0.4rem;
    font-size: 1.1rem;
    width: 250px;
    align-self: center;
    margin-top: 1rem;
    cursor: pointer;
    :hover {
      background: hsl(28, 98%, 80%);
    }
  }
`;

export const SubTitle = styled.h3`
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 1.5rem;
  padding: 1rem;
  margin: 1rem 0;
`;

export const OfferButton = styled.button`
  border-radius: 0.75rem;
  border: none;
  background: hsl(0, 79%, 72%);
  color: white;
  padding: 0.4rem;
  font-size: 1.1rem;
  width: 200px;
  align-self: center;
  margin-top: 1rem;
  cursor: pointer;
  :hover {
    background: hsl(28, 98%, 80%);
  }
`;

export const Beta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #f66969ff;
  color: black;
  font-weight: bold;
  font-size : 20px;
  padding: 1rem;
  width: 100%;
  height: 36px;
`;

export const NoBold = styled.span`
  font-weight: normal;
`

export default Container;
